<template>
  <el-form ref="form" label-position="top" :model="form" :rules="rules" label-width="120px" class="app-container view-container">
    <BjDivider>
      {{ $t('BusinessPurchaseOrder2.detailTitle') }}
      <template #right>
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="handleConfirm">{{ $t('okText') }}</el-button>
      </template>
    </BjDivider>
    <template>
      <el-row :gutter="10">
        <!-- <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrder2.form.vendorId')">
            <BjInput v-model="form.vendorId" :placeholder="$t('inputText')" :maxlength="16" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrder2.container')">
            <BjInput v-model="form.trackingNumber" :placeholder="$t('inputText')" :maxlength="MAX_LENGTH.DEFAULT" />
          </el-form-item>
        </el-col> -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrder2.Unit')" prop="shippingMethod">
            <BjSelectLov v-model="form.shippingMethod" :option-list="SHIPPING_METHODS" @change="changeShippingMethod" />
          </el-form-item>
        </el-col>
        <el-col v-if="form.shippingMethod === 'Pallet'" :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrder2.form.palletQty')" prop="palletQty">
            <BjInputNumber v-model="form.palletQty" :placeholder="$t('inputText')" class="full-width" clearable :max="140" :controls="false" @blur="_getCsgPurchaseOrderUnavailableTime" />
          </el-form-item>
        </el-col>
        <el-col v-if="form.shippingMethod === 'Carton'" :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrder2.form.carton')" prop="containerQty">
            <BjInputNumber v-model="form.containerQty" :placeholder="$t('inputText')" class="full-width" clearable :controls="false" />
          </el-form-item>
        </el-col>
        <div v-if="form.shippingMethod == 'Container'">
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseOrder2.form.containerId')" prop="containerId">
              <BjInput v-model="form.containerId" :placeholder="$t('inputText')" :maxlength="MAX_LENGTH.DEFAULT" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseOrder2.form.containerLength')" prop="containerLength">
              <BjSelectLov v-model="form.containerLength" :option-list="CONTAINER_LENGTH_LIST" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseOrder2.dropOffMethod')" prop="dropOffMethod">
              <BjSelectLov v-model="form.dropOffMethod" :option-list="DROPOFF_METHODS_LIST" @change="_getCsgPurchaseOrderUnavailableTime" />
            </el-form-item>
          </el-col>
        </div>
        <el-col v-if="showTime" :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrder2.receiveDate')" prop="receiveDate">
            <BjDateTimerPicker v-model="form.receiveDate" :picker-options="pickerOptions" />
          </el-form-item>
        </el-col>
        <el-col v-if="form.shippingMethod != 'Container'" :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrder2.form.thirdCode')">
            <BjInput v-model="form.thirdCode " :placeholder="$t('inputText')" :maxlength="MAX_LENGTH.DEFAULT" />
          </el-form-item>
        </el-col>
      </el-row>
    </template>
    <div class="bj-row mt20">
      <BjDivider>
        {{ $t('BusinessPurchaseComponentsPur.information') }}
        <template>
          <el-button type="primary" @click="onAdd">{{ $t('BusinessPurchaseComponentsPur.addingGoods') }}</el-button>
          <el-button type="primary" @click="onImport">{{ $t('EXCELImportText') }}</el-button>
          <el-button :disabled="selection.length === 0" @click="onDelete()">{{ $t('delText') }}</el-button>
        </template>
      </BjDivider>
      <div class="bj-col bj-col-24" style="border-left:none">
        <el-table :data="form.purchaseOrderGoods" border script max-height="600px" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="70" align="center" fixed="left" />
          <el-table-column prop="standardSkuCode" label="SKU" align="center" fixed="left" width="170" />
          <el-table-column prop="skuName" :label="$t('BusinessPurchaseOrder2.form.skuName')" align="center" width="170" />
          <el-table-column align="center" width="130">
            <template #header>
              <span class="must">*</span> {{ $t('goodsSku.detail.qty') }}
            </template>
            <template v-slot="{ row }">
              <BjInputNumber v-model="row.planQty" class="full-width" clearable :controls="false" />
            </template>
          </el-table-column>
          <el-table-column align="center" width="150">
            <template #header>
              {{ $t('BusinessPurchaseOrder2.form.batchCode') }}
            </template>
            <template v-slot="{ row }">
              <BjInput v-model="row.batchCode" class="full-width" clearable :controls="false" :disabled="row.needExpired !== 1" />
            </template>
          </el-table-column>
          <el-table-column prop="expiryDate" label="Product Expiry Date" align="center" width="170">
            <template #header>
              {{ $t('BusinessPurchaseOrder2.form.expiryDate') }}
            </template>
            <template v-slot="{ row }">
              <BjDateTimerPicker v-model="row.expiryDate"/>
            </template>
          </el-table-column>
          <el-table-column :label="$t('goodsPage.length')" prop="length" align="center" width="150">
            <template v-slot="{ row }">
              {{ row.length }} cm
            </template>
          </el-table-column>
          <el-table-column :label="$t('goodsPage.width')" prop="width" align="center" width="150">
            <template v-slot="{ row }">
              {{ row.width }} cm
            </template>
          </el-table-column>
          <el-table-column :label="$t('goodsPage.height')" prop="height" align="center" width="150">
            <template v-slot="{ row }">
              {{ row.height }} cm
            </template>
          </el-table-column>
          <el-table-column :label="$t('goodsPage.volume')" prop="volume" align="center" width="170">
            <template v-slot="{ row }">
              {{ (row.width * row.height * row.length / 1000000) }} m³
            </template>
          </el-table-column>
          <el-table-column :label="$t('goodsPage.weight')" prop="weight" align="center" width="150">
            <template v-slot="{ row }">
              {{ row.weight }} kg
            </template>
          </el-table-column>
          <el-table-column prop="" :label="$t('table.operationText')" align="center">
            <template slot-scope="{ row, $index }">
              <el-button @click="onDelete(row, $index)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    
      <!-- 下载PDF使用的div，定位向左3000像素 -->
      <div class="bj-col bj-col-24" ref="downPDFTemp" style="position: absolute;left: -3000px;border: none;">
        <!-- 入库单基本信息 -->
        <BjDivider>{{ $t('BusinessPurchaseOrder2.detailTitle') }}</BjDivider>
        <div class="bj-row mt20">
          <div class="bj-col bj-col-12">
            <div class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder3.id') }}</div>
              <div class="bj-form-item-value">{{ downloadData.code }}</div>
            </div>
            <div class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder3.Status') }}</div>
              <div class="bj-form-item-value">{{ downloadData.status }}</div>
            </div>
            <div class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder3.warehouseReceiptRemarks') }}</div>
              <div class="bj-form-item-value">{{ downloadData.customerRemarks }}</div>
            </div>
          </div>
          <div class="bj-col bj-col-12">
            <div class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder3.Date') }}</div>
              <div class="bj-form-item-value">{{ downloadData.creationDate | timeFilters }}</div>
            </div>
            <div class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder3.Item') }}</div>
              <div class="bj-form-item-value">{{ downloadData.purchaseOrderGoods && downloadData.purchaseOrderGoods.length }}</div>
            </div>
          </div>
        </div>
        <div class="bj-row mt20">
          <div class="bj-col bj-col-12">
            <div class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder2.Unit') }}</div>
              <div class="bj-form-item-value">{{ downloadData.shippingMethod }}</div>
            </div>
            <template v-if="downloadData.shippingMethod === 'Container'">
              <div class="bj-form-item">
                <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder2.form.containerId') }}</div>
                <div class="bj-form-item-value">{{ downloadData.containerId }}</div>
              </div>
            </template>
            <template v-if="downloadData.shippingMethod !== 'Container'">
              <div v-if="downloadData.shippingMethod === 'Pallet'" class="bj-form-item">
                <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder3.PalletQty') }}</div>
                <div class="bj-form-item-value">{{ downloadData.palletQty }}</div>
              </div>
              <div v-if="downloadData.shippingMethod === 'Carton'" class="bj-form-item">
                <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder3.cartonQty') }}</div>
                <div class="bj-form-item-value">{{ downloadData.containerQty }}</div>
              </div>
              <div class="bj-form-item">
                <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder2.form.thirdCode') }}</div>
                <div class="bj-form-item-value">{{ downloadData.thirdCode }}</div>
              </div>
            </template>
          </div>
          <div class="bj-col bj-col-12">
            <template v-if="downloadData.shippingMethod === 'Container'">
              <div class="bj-form-item">
                <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder2.form.containerLength') }}</div>
                <div class="bj-form-item-value">{{ downloadData.containerLength }}</div>
              </div>
              <div class="bj-form-item">
                <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder2.dropOffMethod') }}</div>
                <div class="bj-form-item-value">{{ downloadData.dropOffMethod }}</div>
              </div>
            </template>
            <div class="bj-form-item">
              <div class="bj-form-item-label">{{ $t('BusinessPurchaseOrder2.receiveDate') }}</div>
              <div class="bj-form-item-value">{{ downloadData.receiveDate | timeFilters }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BjDialogList ref="dialogList" multiple :config="$BjDialogListConfig.skuDefault('SelectSKUText',{ columns: columns, search: search})" @confirm="onAddDialogConfirm" :check-method="checkMethod" />
    <!-- EXCEL导入 -->
    <ExcelImportDialog ref="ExcelImport" @submit="getTableData" />
    <!-- 新增入库单后弹出‘是否下载PO’确认框 -->
    <el-dialog
      :title="$t('goodsPage.dPs1')"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleDialogClose">
      <span>{{$t('goodsPage.dPs2')}}</span><br>
      <br>
      <span>{{$t('goodsPage.dPs3')}}</span><br>
      <br>
      <span>{{$t('goodsPage.dPs4')}}</span><br>
      <br>
      <span>{{$t('goodsPage.dPs5')}}</span><br>
      <br>
      <br>
      <span>Best Regards</span><br>
      <span>CSG 3PL Team</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="handleDialogConfirm">{{$t('goodsPage.dPs6')}}</el-button>
      </span>
    </el-dialog>
  </el-form>
</template>
<script>
import { purchaseApi } from '@/api';
import viewMiXin from '@/utils/view-mixin.js';
import BjInputNumber from '@/packages/BjInputNumber';
import ExcelImportDialog from './ExcelImportDialog.vue';
import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';
import moment from 'moment';
import {PO_CONTAINERLENGTH_STATUS_LIST} from '@/utils/constants';
const defaultForm = () => {
  return {
    thirdCode: null,
    containerId: null,
    containerLength: null,
    dropOffMethod: null,
    containerType: null,
    palletQty: null,
    finishTime: null,
    receiveDate: null, // moment().format('YYYY-MM-DD HH:mm:ss'),
    remark: null,
    shippingMethod: null,
    status: null,
    vendorId: null,
    vendorName: null,
    purchaseOrderGoods: [],
    trackingNumber: null,
    containerQty: null,
    nonStandardPallet: null
  };
};
export default {
  name: 'PurchaseViewForm',
  components: { BjInputNumber, ExcelImportDialog },
  mixins: [viewMiXin],
  props: {},
  data() {
    return {
      colSpan: 6,
      form: defaultForm(),
      selection: [],
      index: null,
      SHIPPING_METHODS: [
        {value: 'Container', label: 'Container'},
        {value: 'Pallet', label: 'Pallet'},
        {value: 'Carton', label: 'Carton'},
      ],
      CONTAINER_LIST: [
        {value: 'Pallet', label: 'Pallet'},
        {value: 'Loose', label: 'Loose'}
      ],
      CONTAINER_LENGTH_LIST: PO_CONTAINERLENGTH_STATUS_LIST,
      DROPOFF_METHODS_LIST: [
        {value: 'SideLoader', label: this.$t('BusinessPurchaseOrder2.side')},
        {value: 'Trailer', label: this.$t('BusinessPurchaseOrder2.trailer')},
      ],
      pickerOptions: {
        // 限制时间选择今天及以后的
        disabledDate(time) {
          return time.getTime() < new Date().getTime() - 3600 * 1000 * 24;
        },
      },
      columns: [
        {
          prop: 'skuName',
          label: 'BjDialogListConfig.SKUname',
          width: 160,
        },
        {
          prop: 'standardSkuCode',
          label: 'BjDialogListConfig.SKUcode',
          width: 160,
        }
      ],
      search: [
        {
          placeholder: 'BjDialogListConfig.SKUname',
          key: 'skuName',
        },
        {
          placeholder: 'BjDialogListConfig.SKUcode',
          key: 'skuCode',
        }
      ],
      rules: {
        thirdCode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        vendorId: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        vendorName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        receiveDate: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        shippingMethod: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        palletQty: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        containerId: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        containerQty: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        containerLength: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        dropOffMethod: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
      },
      dialogVisible: false,
      tableData:[],
      downloadData:{},
      neverShow: false,
    };
  },
  computed: {
    showTime() {
      if ((this.form.shippingMethod === 'Container' && this.form.dropOffMethod) || (this.form.shippingMethod === 'Pallet' && this.form.palletQty > 0) || this.form.shippingMethod === 'Carton') {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    if (this.isEdit) this.getData();
  },
  methods: {
    checkMethod(row) {
      if (!this.form.purchaseOrderGoods.length) {
        return true;
      }
      const finder = this.form.purchaseOrderGoods.find(item => {
        return item.id === row.id;
      });
      if (finder) {
        return finder.needExpired === 1;
      } else {
        return true;
      }
    },
    checkHasSameItem() {
      const arr = this.form.purchaseOrderGoods.filter(item => {
        return item.needExpired !== 1;
      });
      return this.hasDuplicateIds(arr);
    },
    hasDuplicateIds(arr) {
      const seen = new Set();
      for (const obj of arr) {
        // 提取 batchCode 和 id 并生成唯一键
        const key = JSON.stringify([obj.batchCode, obj.skuCode]);
        if (seen.has(key)) {
          return true; // 发现重复
        }
        seen.add(key);
      }
      return false; // 无重复
    },
    _getCsgPurchaseOrderUnavailableTime(bstop = true) {
      this.$nextTick(() => {
        if ((this.form.shippingMethod === 'Container' && this.form.dropOffMethod) || (this.form.shippingMethod === 'Pallet' && this.form.palletQty > 0) || this.form.shippingMethod === 'Carton') {
          const { dropOffMethod, palletQty, shippingMethod } = this.form;
          purchaseApi.getCsgPurchaseOrderUnavailableTime({
            dropOffMethod, palletQty, shippingMethod,
            code: this.form.code || null
          }).then(res => {
            this.showTime = false;
            setTimeout(() => {
              this.showTime = true;
              if (bstop) {
                this.form.receiveDate = null;
              }
            }, 300);
            this.pickerOptions = {
              disabledDate(time) {
                const dateStr = moment(new Date(time)).format('YYYY-MM-DD');
                const isWeekend = new Date(time).getDay() === 0 || new Date(time).getDay() === 6;
                return res.includes(dateStr) || time.getTime() < new Date().getTime() - 3600 * 1000 * 24 || isWeekend;
              },
            };
          });
        }
      });
    },
    changeShippingMethod() {
      this.form.containerId = null;
      this.form.containerType = null;
      this.form.containerLength = null;
      this.form.dropOffMethod = null;
      this.form.palletQty = null;
      this._getCsgPurchaseOrderUnavailableTime();
    },
    getTableData(data) {
      this.form.purchaseOrderGoods = data;
    },
    onImport() {
      this.$refs.ExcelImport.show();
    },
    onAdd() {
      this.$refs.dialogList.show();
    },
    onDelete(row, index) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
          row
            ? this.form.purchaseOrderGoods.splice(index, 1)
            : (this.form.purchaseOrderGoods = this.form.purchaseOrderGoods.filter(
              row => !this.selection.map(e => e.skuCode).includes(row.skuCode),
            ));
      });
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    // 添加采购单、商品回调相关
    onAddDialogConfirm(data) {
      if (this.form.purchaseOrderGoods.length > 0) {
        // const newData = data;
        data.forEach(item=>{
          this.$set(item, 'planQty', 1);
          this.$set(item, 'batchCode', '');
        })
        this.form.purchaseOrderGoods = [...this.form.purchaseOrderGoods, ...data]
        // const oldData = this.form.purchaseOrderGoods;
        // const differentItems = this.$lodash.differenceBy(newData, oldData, 'skuCode');
        // if (differentItems.length) {
        //   differentItems.forEach(item => {
        //     this.$set(item, 'planQty', 1);
        //   });
        // }
        // this.form.purchaseOrderGoods = [...oldData, ...differentItems];
      } else {
        this.form.purchaseOrderGoods = data;
        this.form.purchaseOrderGoods.forEach(item => {
          this.$set(item, 'planQty', 1);
          this.$set(item, 'batchCode', '');
      });
      }
    },
    handleClose() {
      this.tryCancel();
    },
    handleConfirm() {
      if (this.checkHasSameItem()) {
        this.$message.warning(this.$t('BusinessStockDistributionQtyViewForm.confirmText2'));
        return;
      }
      // 托盘体积    1.15*1.15*1.45米
      // 集装箱体积  1.15*1.15*1.45米*20
      // let palletVolume = 1.15*1.15*1.45
      // 使用reduce方法计算 商品体积
      // let goodsVolume = this.form.purchaseOrderGoods.reduce((accumulator, currentValue) => {
      //   let product = currentValue.width * currentValue.height * currentValue.length / 1000000 * currentValue.planQty;
      //   return accumulator + product;
      // }, 0);

      // row.width * row.height * row.length / 1000000   planQty
      this.$refs.form.validate(valid => {
        if (valid) {
          // 根据集装箱体积或者托盘体积判断体积是否够用
          // if(this.form.shippingMethod == 'Container'){
          //   if(palletVolume*20 < goodsVolume) return this.msgError(this.$t('BusinessQuotation.errMsg8'))
          // }
          // if(this.form.shippingMethod == 'Pallet'){
          //   if(palletVolume*this.form.palletQty < goodsVolume) return this.msgError(this.$t('BusinessQuotation.errMsg8'))
          // }
          if (this.form.purchaseOrderGoods.length === 0) return this.msgError(this.$t('BusinessStockDistributionQtyViewForm.msgWarning'));
          for (const item of Object.values(this.form.purchaseOrderGoods)) {
            if (!item.planQty) return this.msgError(this.$t('BusinessQuotation.errMsg2'));
            if(!item.skuCode) return this.msgError(`sku` + this.$t('emptyWarningText'))
          }
          let newArr = []
          const duplicates = {};
          this.form.purchaseOrderGoods.forEach(obj => {
            const key = `${obj.skuCode}-${obj.batchCode}`;
            if (duplicates[key]) {
              newArr.push(`${obj.standardSkuCode}-${obj.batchCode}`)
            }else{
              duplicates[key] = true;
            }
          });
          if(newArr.length > 0){
            this.$message.warning(`${newArr[0]} ${this.$t('dataDuplication')}`)
          }else{
            this.sendData()
          }
        } else {
          return false;
        }
      });
    },
    sendData() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA.purchaseOrderGoods = API_DATA.purchaseOrderGoods.map(row => {
          return {
            batchCode: row.batchCode,
            expiryDate: row.expiryDate,
            planQty: row.planQty,
            skuCode: row.skuCode,
            skuName: row.skuName,
            id: row.id,
            purchaseOrderId: row.purchaseOrderId
          };
        });
      } else {
        API_DATA.purchaseOrderGoods = API_DATA.purchaseOrderGoods.map(row => {
          return {
            batchCode: row.batchCode,
            expiryDate: row.expiryDate,
            planQty: row.planQty,
            skuCode: row.skuCode,
            skuName: row.skuName
          };
        });
      }
      const apiName = (this.isEdit ? 'put' : 'add') + 'CsgPurchaseOrder';
      this.sendApi(apiName, API_DATA);
    },
    sendApi(apiName, API_DATA) {
      purchaseApi[apiName](API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          // 新增 增加弹窗提示用户下载PO单
          if(apiName == 'addCsgPurchaseOrder'){
            purchaseApi['getCsgPurchaseOrderDetail']({ id: res.id }).then(resp=>{
              this.downloadData = resp
            })
            this.dialogVisible = true
          }else{
            // 编辑 保存原有逻辑
            this.onBack()
          }
        }
      });
    },
    handleDialogClose(){
      this.dialogVisible = false
      this.onBack()
    },
    handleDialogConfirm(){
      const PDFView = this.$refs.downPDFTemp;
      // 获取分割dom，此处为class类名为item的dom
      const lableListID = document.getElementsByClassName('emptyItem');
      const pageHeight = PDFView.scrollWidth / 841.89 * 595.28; // (横版pdf)
      // 进行分割操作，当dom内容已超出a4的高度，则将该dom前插入一个空dom，把他挤下去，分割
      for (let i = 0; i < lableListID.length; i++) {
          const multiple = Math.ceil((lableListID[i].offsetTop + lableListID[i].offsetHeight) / pageHeight);
          if (this.isSplit(lableListID, i, multiple * pageHeight)) {
              const divParent = lableListID[i].parentNode; // 获取该div的父节点
              const newNode = document.createElement('div');
              newNode.className = 'emptyDiv';
              newNode.style.background = '#ffffff';
              const _H = multiple * pageHeight - (lableListID[i].offsetTop + lableListID[i].offsetHeight);
              console.log(pageHeight, lableListID[i].offsetTop, lableListID[i].offsetHeight);
              newNode.style.height = _H + 'px';
              newNode.style.width = '100%';
              const next = lableListID[i].nextSibling; // 获取div的下一个兄弟节点
              // 判断兄弟节点是否存在
              if (next) {
                  // 存在则将新节点插入到div的下一个兄弟节点之前，即div之后
                  divParent.insertBefore(newNode, next);
              } else {
                  // 不存在则直接添加到最后,appendChild默认添加到divParent的最后
                  divParent.appendChild(newNode);
              }
          }
      }
      html2canvas(PDFView, {
          useCORS: true, // 是否尝试使用CORS从服务器加载图像
          allowTaint: true,
          dpi: 300, // 解决生产图片模糊
          scale: 3, // 清晰度--放大倍数
      }).then(
          (canvas) => {
              const contentWidth = canvas.width;
              const contentHeight = canvas.height;
              // let pageHeight = contentWidth / 592.28 * 841.89 // 一页pdf显示html页面生成的canvas高度;
              const pageHeight = contentWidth / 841.89 * 595.28; // 一页pdf显示html页面生成的canvas高度(横版pdf);
              let leftHeight = contentHeight; // 未生成pdf的html页面高度
              let position = 0; // pdf页面偏移

              // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
              const imgWidth = 808; // 宽度（横版pdf）
              const imgHeight = 841.89 / contentWidth * contentHeight; // （横版pdf）
              const pageData = canvas.toDataURL('image/jpeg', 1.0);
              const PDF = new JsPDF('l', 'pt', 'a4');
              if (leftHeight < pageHeight) {
                  PDF.addImage(pageData, 'JPEG', 20, 20, imgWidth, imgHeight);
              } else {
                  while (leftHeight > 0) {
                      PDF.addImage(pageData, 'JPEG', 20, position, imgWidth, imgHeight);
                      leftHeight -= pageHeight;
                      position -= 595.28; // (横版pdf)
                      // position -= 841.89
                      if (leftHeight > 0) {
                          PDF.addPage();
                      }
                  }
              }
              PDF.save('Receipt Information.pdf'); // 下载标题
              // // 将前面处理内容分割问题在页面中加上的空白占位结点去掉
              const emptyDiv = document.getElementsByClassName('emptyDiv');
              for (let i = 0; i < emptyDiv.length; i++) {
                  emptyDiv[i].remove();
                  i = i - 1;
              }
      });
      this.dialogVisible = false
      this.onBack()
    },
    onBack(){
      setTimeout(() => {
        this.cancel();
        this.form = defaultForm();
      }, 200);
    },
    getData() {
      purchaseApi.getCsgPurchaseOrderDetail({
        id: this.$route.query.id,
      }).then(async res => {
        const skuList = res.purchaseOrderGoods.map(item => item.skuCode);
        purchaseApi.purchaseGoodsImport(skuList).then(res2 => {
          const list = [];
          if (res2.length > 0) {
            res2.forEach(v1 => {
              res.purchaseOrderGoods.forEach(v2 => {
                if (v2.skuCode === v1.skuCode) {
                  list.push({...v2, ...v1});
                }
              });
            });
          }
          res.purchaseOrderGoods = list;
          this.form = {...this.form, ...res};
          this._getCsgPurchaseOrderUnavailableTime(false);
        });
      });
    },
  },
};
</script>
<style scoped lang="scss">
.app-container .must {
  color: #ff1818;
}
</style>
